var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnerrorPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7381 50.9681C58.3409 50.571 58.1178 50.0324 58.1178 49.4707L58.1178 43.1177C58.1178 43.1177 58.1178 43.1177 58.1178 43.1177H47.5294C46.7497 43.1177 46.1176 43.7498 46.1176 44.5294V67.1175C46.1176 67.8972 46.7497 68.5292 47.5294 68.5292H64.4704C65.2501 68.5292 65.8821 67.8972 65.8821 67.1175V51.588L60.2355 51.5883C59.6739 51.5884 59.1352 51.3653 58.7381 50.9681ZM67.9996 49.447V44.4957L67.9998 44.5294V67.1175C67.9998 69.0667 66.4196 70.6468 64.4704 70.6468H47.5294C45.5802 70.6468 44 69.0667 44 67.1175V44.5294C44 42.5802 45.5802 41.0001 47.5294 41.0001L60.2195 41.0001C60.8183 40.9957 61.4048 41.2457 61.8182 41.7109L67.4648 48.0636C67.8108 48.4528 67.994 48.9461 67.9996 49.447ZM65.8821 49.4704L60.2354 43.1177L60.2354 49.4707L65.8821 49.4704ZM55.9996 52.647H50.3526V50.5294H55.9996V52.647ZM61.6467 58.294H50.3527V56.1764H61.6467V58.294ZM50.3527 63.941H61.6467V61.8234H50.3527V63.941Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnerrorPreview);
export default __webpack_public_path__ + "static/media/onerror_preview.ca94c7740e0469dd8e2561bc3825972d.svg";
export { ForwardRef as ReactComponent };